import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // StrictMode = double call API en DEV, mais pas en PRODUCTION
    <React.StrictMode>
        <App/>
    </React.StrictMode>
);
